var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPinMarker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7 14.8c-.2 0-.3.1-.4.2-.1.1-.1.3 0 .4s.2.2.4.3c4.3.4 6.8 1.6 6.8 2.6 0 1.1-3.6 2.7-9.4 2.7s-9.5-1.6-9.5-2.7c0-1 2.5-2.2 6.8-2.6.2 0 .3-.1.4-.3.1-.1.1-.3 0-.4s-.2-.2-.4-.2c-3.5.3-7.6 1.4-7.6 3.5 0 2.3 5.3 3.6 10.4 3.6s10.4-1.3 10.4-3.6c-.2-2-4.3-3.2-7.9-3.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 10.2v7.7c0 .2.2.4.5.4.2 0 .4-.2.4-.4v-7.7c2.1-.2 3.7-2.1 3.6-4.3-.1-2.1-1.9-3.8-4-3.8S8.1 3.8 8 5.9c-.2 2.2 1.4 4 3.5 4.3z"
  })));
}

export default SvgPinMarker;